import { axiosInstance } from '@/axios/config';
import {
  buildClassificationFilterUrl,
  mapClassificationsForFilter,
  readIncludeDeletedClassificationsPreference,
  persistIncludeDeletedClassificationsPreference,
} from '@/helper/classificationFilterHelper';

/**
 * Shared logic for request-filter classification dropdowns.
 * Override `classificationFilterTypes` in component data when fewer types are needed (e.g. [5] for quality only).
 */
export default {
  data() {
    return {
      includeDeletedClassifications: readIncludeDeletedClassificationsPreference(),
      _skipClassificationFilterWatch: true,
    };
  },

  watch: {
    includeDeletedClassifications(value) {
      persistIncludeDeletedClassificationsPreference(value);
      if (this._skipClassificationFilterWatch) {
        return;
      }
      this.reloadAllClassificationsForFilter();
    },
  },

  methods: {
    getClassificationFilterTypes() {
      return this.classificationFilterTypes || [0, 1, 2, 3, 4, 5];
    },

    requestClass(data) {
      return mapClassificationsForFilter(data);
    },

    assignClassificationFilterPayload(type, payload) {
      const items = Array.isArray(payload) ? payload : [];
      this.requestClass(items);

      const keyByType = {
        0: 'selesAgentType',
        1: 'selesMangerType',
        2: 'fundingMangerType',
        3: 'marteryMangerType',
        4: 'genaralMangerType',
        5: 'qualityUserType',
      };
      const key = keyByType[type];
      if (key && Object.prototype.hasOwnProperty.call(this, key)) {
        this[key] = items;
      }
    },

    getRequestClassification(type) {
      const url = buildClassificationFilterUrl(type, this.includeDeletedClassifications);
      return axiosInstance.get(url).then((res) => {
        const payload = res.data.payload || [];
        this.assignClassificationFilterPayload(type, payload);
        return payload;
      });
    },

    reloadAllClassificationsForFilter() {
      const types = this.getClassificationFilterTypes();
      return Promise.all(types.map((type) => this.getRequestClassification(type)));
    },

    enableClassificationFilterWatchAfterInitialLoad() {
      this._skipClassificationFilterWatch = false;
    },
  },
};
